<div class="input-group" [ngClass]="{ 'input-group-sm': small_input }">
  <select name='selected_hour' ngDefaultControl class="form-control" [(ngModel)]="selectedHour" (change)="onTimeChange()">
    <option *ngFor="let hour of hours" [value]="hour">{{ hour < 10 ? '0' + hour : hour }}</option>
  </select>
  <div class="input-group-prepend" style="border: none; padding-left: 3px; padding-right: 3px"><span class="input-group-text">:</span></div>
  <select name='selected_minute' ngDefaultControl class="form-control" [(ngModel)]="selectedMinute" (change)="onTimeChange()">
    <option *ngFor="let minute of minutes" [value]="minute">{{ minute < 10 ? '0' + minute : minute }}</option>
  </select>
  <div class="input-group-append" *ngIf="!time_in_24">
    <button type="button" class="btn btn-default btn-outline-primary" (click)="onMeridianChange()">{{ meridian }}</button>
  </div>
</div>
